/**
 * STATIC APP CONFIG ONLY.
 *
 * Dynamic / CMS-editable content (slides, notices, management, stats, gallery,
 * results, academics, admissions, about, contact info...) no longer lives here.
 * It is fetched through the content service:
 *
 *   src/services/content.js  ->  src/lib/apiClient.js  ->  public/data/*.json
 *
 * Set REACT_APP_API_URL to point those fetches at a real backend (see .env.example).
 *
 * What stays here is identity + navigation: needed at first paint, route-bound,
 * and not something an editor changes day-to-day.
 */

export const SCHOOL = {
  name: "Khulna Collegiate Girls' School",
  college: "KCC Women's College",
  short: "KCGS & KCCWC",
  est: 1938,
  eiin: "114256",
  managedBy: "Managed by Khulna City Corporation",
  address: "Khulna Sadar, Khulna – 9000",
  officeHours: "Sat–Thu: 8AM–4PM",
  phone: "+880-41-730451",
  email: "info@kcgs-kccwc.edu.bd",
  motto: "জ্ঞানই আলো — Knowledge is Light",
};

export const NAV = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  {
    id: "academics",
    label: "Academics",
    // Dropdown: one dedicated academics page per institution. `id` doubles as
    // the URL path, so these resolve to /academics/<key> and the key must match
    // a tab key in the `academics` content blob.
    children: [
      { id: "academics/kcns", label: "KCNS", note: "Primary" },
      { id: "academics/kcgs", label: "KCGS", note: "School & College Section" },
      { id: "academics/honors", label: "KCCWC", note: "Affiliated with Khulna University" },
    ],
  },
  {
    id: "admissions",
    label: "Admissions",
    children: [
      { id: "admissions/kcns", label: "KCNS", note: "Primary" },
      { id: "admissions/kcgs", label: "KCGS", note: "School & College Section" },
      { id: "admissions/honors", label: "KCCWC", note: "Affiliated with Khulna University" },
    ],
  },
  {
    id: "gallery",
    label: "Gallery",
    children: [
      { id: "gallery/kcns", label: "KCNS", note: "Primary" },
      { id: "gallery/kcgs", label: "KCGS", note: "School & College Section" },
      { id: "gallery/honors", label: "KCCWC", note: "Affiliated with Khulna University" },
    ],
  },
  { id: "activity", label: "Activity" },
  { id: "contact", label: "Contact" },
];
